// extracted by mini-css-extract-plugin
export var filterIncDec = "_3a-0";
export var leftBorder = "_3a-1";
export var rightBorder = "_3a-2";
export var stringInput = "_3a-3";